import styled from 'styled-components';
import { Icon } from '../../Icon/Icon';
import { Tooltip } from '@salecycle/ui-component-library';

const NavMenuItemElement = styled.div`
  display: inline-block;

  .active & {
    background-color: ${({ theme }) => theme.vars.newColor.blue1};
  }

  :hover {
    background-color: ${({ theme }) => theme.vars.newColor.blue2};
  }
`;

const IconElement = styled.div`
  display: flex;
  color: ${({ theme }) => theme.vars.newColor.white};
  font-size: 18px;
  height: 46px;
  width: 46px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export interface IProps {
  /** Icon style for icon item */
  icon: string;

  /** Description of section for tooltip e.g. "Home" */
  tooltipDescription?: string;
}

export const MainNavLink = ({ icon, tooltipDescription }: IProps) => (
  <div data-testid="MainNavLink">
    {tooltipDescription ? (
      <Tooltip title={tooltipDescription}>
        <NavMenuItemElement data-testid="MainNavIcon">
          <IconElement>
            <Icon icon={icon} />
          </IconElement>
        </NavMenuItemElement>
      </Tooltip>
    ) : (
      <NavMenuItemElement data-testid="MainNavIcon">
        <IconElement>
          <Icon icon={icon} />
        </IconElement>
      </NavMenuItemElement>
    )}
  </div>
);
